// Returns a new array with the item moved. A shallow copy is enough: the only caller (file reordering) copies
// each item afterwards. The former double deep clone copied every file (FE-PERF-F15).
export const arrayMove = (arr: any[], oldIndex: number, newIndex: number) => {
  const clone = [...arr]

  if (newIndex >= clone.length) {
    let k = newIndex - clone.length + 1
    while (k--) {
      clone.push(undefined)
    }
  }
  clone.splice(newIndex, 0, clone.splice(oldIndex, 1)[0])
  return clone
}
